import * as joint from '@joint/core'

/**
 * C4 Cylinder shape - database cylinder
 */
export const C4Cylinder = joint.dia.Element.define(
  'c4.Cylinder',
  {
    size: { width: 200, height: 180 },
    attrs: {
      // Cylinder body (using path for proper cylinder shape)
      body: {
        refWidth: '100%',
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
        d: 'M 0 30 L 0 150 Q 0 180 100 180 Q 200 180 200 150 L 200 30 Q 200 60 100 60 Q 0 60 0 30',
      },
      // Top ellipse
      top: {
        refWidth: '100%',
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
        d: 'M 0 30 Q 0 0 100 0 Q 200 0 200 30 Q 200 60 100 60 Q 0 60 0 30',
      },
      nameLabel: {
        refX: '50%',
        refY: 75,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 95,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Database]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 120,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '85%',
          height: 50,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      {
        tagName: 'path',
        selector: 'body',
      },
      {
        tagName: 'path',
        selector: 'top',
      },
      {
        tagName: 'text',
        selector: 'nameLabel',
      },
      {
        tagName: 'text',
        selector: 'typeLabel',
      },
      {
        tagName: 'text',
        selector: 'descriptionLabel',
      },
    ],
  }
)

export function createCylinder(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[Database: ${technology}]` : '[Database]'

  const cylinder = new C4Cylinder({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      top: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return cylinder
}
